import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Header/header";
import Footer from "./Footer/Footer";
import ProductBuyPage from "./ProductBuyPage/ProductBuyPage";
import products from "./DemoData/demoData";
import HomePage from "./HomePage/HomePage";
import CheckoutPage from "./CheckoutPage/CheckoutPage";
import Test from "./DemoData/test"; // Importing the Test component

function App() {
  // return <Test />;
  return (
    <div
      style={{
        display: "grid",
        gridTemplateRows: "60px 1fr 60px",
        minHeight: "100vh",
      }}
    >
      <Router>
        <Header />
        <div style={{ overflowY: "auto" }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/product/:id"
              element={<ProductBuyPage products={products} />}
            />
            <Route path="/checkout" element={<CheckoutPage />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
